var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"products-wrapper"},[_c('div',{staticClass:"inner-wrapper"},[_vm._l((_vm.products),function(product){return _c('product-card',{key:product.id,attrs:{"product":product}})}),(_vm.loadMore)?_c('more-products-card',{on:{"loadMoreProducts":_vm.handleLoadMoreProducts}}):_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }